import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilService } from 'src/app/shared/services';

@Component({
  selector: 'app-sip-hamburger',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sip-hamburger.component.html',
  styleUrls: ['./sip-hamburger.component.scss']
})
export class SipHamburgerComponent {

  constructor(
    public util: UtilService
  ) {}

  redirect() {
    const queryParams = {
      'utm_source': 'internal_ketto',
      'utm_medium': 'home'
    }
    this.util.router.navigate(['/new/sip'], {queryParams: queryParams, queryParamsHandling: 'merge'});
  }

}
